import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {interval, Subject, Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GtNotificationService {
  originalPageTitle: string;
  intervalSubscription: Subscription;

  public errorNotification = new Subject<string>();
  public normalNotification = new Subject<string>();
  public clickableNotification = new Subject<ClickableNotification>();

  constructor(private translateService: TranslateService) {}

  addPageTitleNotification(title: string): void {
    if (this.intervalSubscription !== undefined) {
      this.removePageTitleNotification();
    }
    this.originalPageTitle = document.title;
    const notification = title;
    console.log('initializePageTitleNotification');
    this.intervalSubscription = interval(1000).subscribe(() => {
      document.title = document.title === this.originalPageTitle ? notification : this.originalPageTitle;
    });
  }

  removePageTitleNotification(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = undefined;
      document.title = this.originalPageTitle;
      console.log('page title interval cleared');
    }
  }

  showMessage(messageKey: string) {
    this.normalNotification.next(this.translateService.instant(messageKey));
  }

  showErrorMessage(error: any) {
    console.error(error);
    const message = this.translateService.instant('global.error');
    this.errorNotification.next(message);
  }

  customError(error: Error, messageKey?: string) {
    console.log(error);
    const message = this.translateService.instant(messageKey || error.message);
    this.errorNotification.next(message);
  }

  showErrorCustomMessage(errorMsg: string) {
    console.error(errorMsg);
    const message = this.translateService.instant(errorMsg);
    this.errorNotification.next(message);
  }

  showSuccessMessage(successMsg = 'global.ok') {
    const message = this.translateService.instant(successMsg);
    this.normalNotification.next(message);
  }
}

export interface ClickableNotification {
  message: string;
  action: () => void;
}
